export default "__VITE_ASSET__COz2lmsq__"